<template>
    <div class="calendar-wrapper calendar-wrapper-overflow">
        <div v-if="slotsGrid.option('show-dates')" :class="'calendar-date calendar-date--'+slotType">
            <span :class="{'tooltip tooltip-hover': hasCalendarDateTooltip}">
                <span>
                    {{ getDayName(date) }}
                    {{ moment(date).format('D. M.') }}
                </span>

                <div v-if="hasCalendarDateTooltip" class="tooltip-content">
                    <span v-if="slotType === 'holidays'">{{ __('National holiday') }}</span>
                    <span v-if="slotType === 'vacations'">{{ __('Holiday') }}</span>
                </div>
            </span>
        </div>
        <div v-else class="calendar-date">
            <span>{{ getDayNameFull(date) }}</span>
        </div>

        <div class="calendar-box calendar-overflow" :class="{ disabled: slotsGrid.isDateDisabled(date) }">
            <div class="calendar-timetable">
                <div v-for="index in maximumSlots" :key="index" class="calendar-time tooltip" :data-index="index">
                    <a
                        class="time-slot"
                        :class="slotsGrid.getClasses(slots, index)"
                        draggable="true"
                        @click="slotsGrid.toggle(date, index, mode)"
                        @dragenter="slotsGrid.toggle(date, index, mode)"
                    ></a>

                    <div class="tooltip-content">
                        <strong>{{ time(index) }}</strong>
                        <span>{{ getTooltipTitle(index) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SlotsParser from '@/core/SlotsParser'

export default {
    props: {
        slots: {
            type: Array,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            required: false,
            default: null
        },
        tooltipTable: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            maximumSlots: 28,
            slotType: null
        }
    },
    computed: {
        ...mapGetters({
            slotsGrid: 'general/slotsGrid'
        }),
        hasCalendarDateTooltip() {
            var bool = false
            var that = this

            this.slots.forEach(item => {
                if(item.type === "vacations" || item.type === "holidays") {
                    bool = true
                    that.slotType = item.type
                } 
            })

            return bool
        }
    },
    mounted() {
        this.slider()
        window.addEventListener('resize', this.onResize)
    },
    methods: {
        getDayName(date) {
            return moment(date).format('dd')
        },
        getDayNameFull(date) {
            return moment(date).format('dddd')
        },
        time(index) {
            return SlotsParser.use()
                .toTime([index])[0]
                .map((d) => d.format('H:mm'))
                .join(' - ')
        },
        getTooltipTitle(index) {
            let tooltipTable = this.tooltipTable
            const types = this.slotsGrid.getTypes(this.slots, index)

            if (!tooltipTable) {
                tooltipTable = this.slotsGrid.option('tooltip-table')
            }

            if (types.length === 0) {
                return _.get(tooltipTable, 'default')
            }

            const lastType = _.last(types)

            return _.get(tooltipTable, lastType, lastType)
        },
        slider() {
            $(this.$el).find('.calendar-timetable').not('.slick-initialized').slick({
                centerMode: false,
                arrows: true,
                dots: false,
                slidesToShow: 16,
                slidesToScroll: 1,
                initialSlide: 0,
                infinite: false,
                mobileFirst: true,
                focusOnSelect: false,
                nextArrow: '<button class="slick-next"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></button>',
                prevArrow: '<button class="slick-prev"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-left" class="svg-inline--fa fa-angle-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg></svg></button>',
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 20,
                            slidesToScroll: 8
                        }
                    },
                    {
                        breakpoint: 1400,
                        settings: 'unslick'
                    }
                ]
            })
        },
        onResize(event) {
            this.slider()
        }
    }
}
</script>
